import { ComponentProps, useEffect, useRef } from 'react';
import { getDefaultClassNames, type DayButton } from 'react-day-picker';

import { Button } from '@/components/common';
import { mergeClasses } from '@/utils';

export const CalendarDayButton = ({
  className,
  day,
  modifiers,
  ...props
}: ComponentProps<typeof DayButton>) => {
  const defaultClassNames = getDefaultClassNames();

  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (modifiers.focused) ref.current?.focus();
  }, [modifiers.focused]);

  return (
    <Button
      ref={ref}
      size="sm"
      variant="secondary"
      data-day={day.date.toLocaleDateString()}
      data-selected-single={
        modifiers.selected &&
        !modifiers.range_start &&
        !modifiers.range_end &&
        !modifiers.range_middle
      }
      data-range-start={modifiers.range_start}
      data-range-end={modifiers.range_end}
      data-range-middle={modifiers.range_middle}
      className={mergeClasses(
        '!text-sm text-brand-primary-darkest !font-medium border-none !size-[36px] hover:bg-neutral-n3 hover:shadow-none active:shadow-none focus:shadow-none data-[selected-single=true]:bg-brand-primary-base data-[selected-single=true]:text-neutral-white data-[range-middle=true]:bg-neutral-n3 data-[range-middle=true]:text-brand-primary-darkest data-[range-start=true]:bg-brand-primary-base data-[range-start=true]:text-neutral-white data-[range-end=true]:bg-brand-primary-base data-[range-end=true]:text-neutral-white group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-ring/50 flex aspect-square w-full h-9 min-w-(--cell-size) flex-col gap-1 leading-none group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:ring-[3px] data-[range-end=true]:rounded-rounded data-[range-middle=true]:rounded-none data-[range-start=true]:rounded-rounded [&>span]:text-xs',
        'disabled:bg-transparent',
        defaultClassNames.day,
        className,
      )}
      {...props}
    />
  );
};
